// extracted by mini-css-extract-plugin
export default {"video":"CompositionsCard_video__G4jNj","video__card":"CompositionsCard_video__card__vMYKj"};